import { AxiosRequestConfig } from 'axios'

import { useApiContext } from '../components/contexts/ApiContext'
import { useUserContext } from '../components/contexts/UserContext'
import { useImmutableObject } from './immutable'
import { StructureType, StructureTypes } from '../models/Structure'

export const useQR = (type: StructureType, id?: string) => {
    const { projectApi, boltConnectionApi } = useApiContext()
    const { selectedOrganization } = useUserContext()

    return useImmutableObject(async () => {
        if (!(id && selectedOrganization)) return
        // NOTE: QR code is a blob type response.
        const options = { responseType: 'blob' } as AxiosRequestConfig
        const orgId = selectedOrganization.id
        const response =
            type === StructureTypes.Project
                ? await projectApi.getProjectQrImageV3({ projectId: id, tenantId: orgId }, options)
                : await boltConnectionApi.getBoltConnectionQrImageV3(
                      { boltConnectionId: id, tenantId: orgId },
                      options
                  )
        return URL.createObjectURL(response.data)
    }, [id, selectedOrganization])
}
